import Router from '@pages/partners'
import PartnersList from '@pages/partners/list/list-partners'
import PartnerProfile from '@pages/partners/partner/profile/profile'
import PartnerCodes from '@pages/partners/partner/codes/codes'
import PartnerCashbacks from '@pages/partners/partner/cashbacks/cashbacks'

export default {
  path: 'partners/',
  components: {
    default: Router,
  },

  children: [{
    path: '',
    redirect: () => ({
      name: 'partners-list',
    })
  }, {
    path: '',
    name: 'partners-list',
    components: { 
      default: PartnersList,
    },
  }, {
    path: ':partner_id/profile',
    name: 'partner-profile',
    components: { 
      default: PartnerProfile,
    },
  }, {
    path: ':partner_id/codes',
    name: 'partner-codes',
    components: { 
      default: PartnerCodes,
    },
  }, {
    path: ':partner_id/cashbacks',
    name: 'partner-cashbacks',
    components: { 
      default: PartnerCashbacks,
    },
  }],
}